import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import html2pdf from 'html2pdf.js';
import styled, { css } from "styled-components";
import { Modal, Button as AntButton } from "antd";
import { useTranslation } from "react-i18next";
import DownloadPDFButton from "../../../DownloadPDFButton";
import useAxios from "../../../../hooks/useAxios";
import moment from "moment";
import { IAwardItem, IGetAwards } from "../../../../models/award.model";
import { getAwards } from "../../../../api/award.api";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";

interface IProps {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    selAwardList: Map<string, IAwardItem>,
}

const Block = styled.div`
  @font-face {
    font-family: 'Aramis Italic';
    src: url('/fonts/aramis.italic.ttf') format('truetype');
  }
  @import url('https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@700&family=Secular+One&display=swap');

  text-align: center;

  .background {
    font-size: 30px;
    width: 1582px;
    height: 1117px;
    background: url(/images/award.png);
    background-size: contain;
    background-repeat: no-repeat;
  }

  .title {
    position: relative;
    top: 270px;
    font-family: 'Secular One', sans-serif;
    font-size: 42px;
    font-weight: bold;
  }

  .name {
    position: relative;
    top: 400px;
    font-family: 'Aramis Italic';
    font-size: 81px;
  }

  .description {
    position: relative;
    top: 430px;
    display: flex;
    justify-content: center;

    .desc-text {
      line-height: 1.3;
      width: 800px;
      text-align: center;  
    }
  }

  .date {
    position: relative;
    top: 480px;
  }

  .desc-text, .date {
    font-family: 'Nanum Myeongjo', serif;
    font-size: 27px;
    font-weight: 700;
  }
`;

const MakeAwardPDFModal = ({visible, setVisible, selAwardList}: IProps) => {
    
    const contentRef = useRef(null);
    const { t, i18n } = useTranslation();
    const { serverDate } = useSelector((state: RootState) => state.serverDate);  

    const { data: res, isLoading, error, execute } = useAxios<IGetAwards>();

    useEffect(() => {
      execute(getAwards());
    }, []);

    const onSave = () => {
        const content = contentRef.current;
        const fileName = 'Canb Award';

        //width: 793.7,
        //  height: 1122.5,
        const options = {
            filename: fileName,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: {
                unit: 'px',
                format: [1582,1117],
                orientation: 'landscape',
            },
        }

        html2pdf().from(content).set(options).save();
    }
    
    const getAwardTitle = (data: IAwardItem[]|undefined, awardCode: string) => {
      const award = data?.find(item => item.awardCode === awardCode);
      return award?.name?.toUpperCase();
    }

    const getAwardDescription = (data: IAwardItem[]|undefined, awardCode: string) => {
      const award = data?.find(item => item.awardCode === awardCode);
      return award?.memo;
    }

    return(
        <Modal
            title={'PDF ' + t('student.student.button15')}
            width={1650}
            open={visible}
            onCancel={() => setVisible(false)}
            style={{top:50}}
            footer={[
            <div className='comm-btn__area justify-content-center'>
                <AntButton
                    className='btn-basic pink'
                    onClick={onSave}
                >
                {t('student.student.button15')}
                </AntButton>
                <AntButton key="cancel" className='btn-basic gray' onClick={() => setVisible(false)}>
                {t('common.button.close')}
                </AntButton>
            </div>
            ]}
        >
        <div className="comm-bx__between" style={{marginBottom:'-50px', paddingRight:'56px'}}>
            <div></div>
            <div className="comm-btn__area right">
                <DownloadPDFButton onClick={onSave} btnText={t('student.student.button15')} />
            </div>
        </div>
        <Block id="testId" ref={contentRef}>
            {Array.from(selAwardList.entries()).map(([key, item]) => {
                return (
                    <>
                        <style type="text/css" media="print">
                          {' @page { size: landscape; } '}
                        </style>
                        <div className="background">
                          <div className="title">
                            OF {getAwardTitle(res?.data, item.awardCode)} AWARD
                          </div>
                          <div className="name">
                            {item.name}
                          </div>
                          <div className="description">
                            <div
                              className="desc-text"
                              dangerouslySetInnerHTML={{ __html: getAwardDescription(res?.data, item.awardCode) || '' }}
                            />
                          </div>
                          <div className="date">
                            Awarded in {moment(serverDate).locale('en').format('MMMM YYYY')}
                          </div>
                        </div>
                    </>
                )
            })}
        </Block>
        </Modal>
    )
}

export default MakeAwardPDFModal;